import PrivateRoute from "@components/PrivateRoute";
import { Caixa } from "@mod/Caixa";
import { CaixaDescricao } from "@mod/Caixa/Descricao";
import { Cliente } from "@mod/Cliente";
import { ClienteDetalhe } from "@mod/Cliente/Detalhes";
import { Conta } from "@mod/Conta";
import { ContratoCliente } from "@mod/ContratoCliente";
import { Despesa } from "@mod/Despesa";
import { Excedente } from "@mod/Excedente";
import { Fatura } from "@mod/Fatura";
import { Home } from "@mod/Home";
import { Linha } from "@mod/Linha";
import { RelatorioCancelamento } from "@mod/Relatorios/Cancelamento";
import { RelatorioConferenciaChip } from "@mod/Relatorios/ConferenciaChip";
import { RelatorioConsumoInternet } from "@mod/Relatorios/ConsumoInternet";
import { RelatorioFatura } from "@mod/Relatorios/Fatura";
import { RelatorioInadimplencia } from "@mod/Relatorios/Inadimplencia";
import { RelatorioInadimplenciaFatura } from "@mod/Relatorios/InadimplenciaFatura";
import { RelatorioNovosInadimplentes } from "@mod/Relatorios/NovosInadimplentes";
import { RelatorioPagamento } from "@mod/Relatorios/Pagamento";
import { RelatorioStatusLinha } from "@mod/Relatorios/StatusLinha";
import { RelatorioValoresEmitidos } from "@mod/Relatorios/ValoresEmitidos";
import { RelatorioValorFranquiaPlanos } from "@mod/Relatorios/ValorFranquiaPlanos";
import { Remessa } from "@mod/Remessa";
import { Retorno } from "@mod/Retorno";
import { Usuario } from "@mod/Usuario";
import { Vendedor } from "@mod/Vendedor";
import React from "react";
import { Redirect, Switch, useHistory } from "react-router-dom";

type AppRoutesProps = {
}

export default function AppRoutes (props: AppRoutesProps) {
    const history = useHistory();

    return (
        <Switch>
            <PrivateRoute path="/relatorio-faturas">
                <RelatorioFatura />
            </PrivateRoute>

            <PrivateRoute path="/relatorio-valores-emitidos">
                <RelatorioValoresEmitidos />
            </PrivateRoute>

            <PrivateRoute path="/relatorio-valor-franquia-planos">
                <RelatorioValorFranquiaPlanos />
            </PrivateRoute>

            <PrivateRoute path="/relatorio-cancelamento">
                <RelatorioCancelamento />
            </PrivateRoute>

            <PrivateRoute path="/relatorio-pagamento">
                <RelatorioPagamento />
            </PrivateRoute>

            <PrivateRoute path="/relatorio-novos-inadimplentes">
                <RelatorioNovosInadimplentes />
            </PrivateRoute>

            <PrivateRoute path="/relatorio-status-linha">
                <RelatorioStatusLinha />
            </PrivateRoute>

            <PrivateRoute path="/cliente/:id">
                <ClienteDetalhe />
            </PrivateRoute>

            <PrivateRoute path="/cliente">
                <Cliente />
            </PrivateRoute>

            <PrivateRoute path="/contrato">
                <ContratoCliente />
            </PrivateRoute>

            <PrivateRoute path="/caixa">
                <Caixa />
            </PrivateRoute>

            <PrivateRoute path="/caixa-pesquisa">
                <CaixaDescricao />
            </PrivateRoute>

            <PrivateRoute path="/conta">
                <Conta />
            </PrivateRoute>

            <PrivateRoute path="/fatura">
                <Fatura />
            </PrivateRoute>

            <PrivateRoute path="/linha">
                <Linha />
            </PrivateRoute>

            <PrivateRoute path="/retorno">
                <Retorno />
            </PrivateRoute>

            <PrivateRoute path="/remessa">
                <Remessa />
            </PrivateRoute>

            <PrivateRoute path="/excedente">
                <Excedente />
            </PrivateRoute>

            <PrivateRoute path="/relatorio-inadimplencia">
                <RelatorioInadimplencia />
            </PrivateRoute>

            <PrivateRoute path="/relatorio-inadimplencia-fatura">
                <RelatorioInadimplenciaFatura />
            </PrivateRoute>

            <PrivateRoute path="/relatorio-conferencia-chip">
                <RelatorioConferenciaChip />
            </PrivateRoute>

            <PrivateRoute path="/relatorio-consumo-internet">
                <RelatorioConsumoInternet />
            </PrivateRoute>

            <PrivateRoute path="/vendedor/:id">
                <Vendedor />
            </PrivateRoute>

            <PrivateRoute path="/vendedor">
                <Vendedor />
            </PrivateRoute>

            <PrivateRoute path="/despesa">
                <Despesa />
            </PrivateRoute>

            <PrivateRoute path="/usuario">
                <Usuario />
            </PrivateRoute>

            <PrivateRoute path="/">
                <Home />
            </PrivateRoute>

            <Redirect to={{
                pathname:"/",
                state: {
                    referrer: history.location.pathname,
                    message: "Recurso não encontrado"
                }
            }} />
        </Switch>
    )
}